import { render } from "./CouponPublish.vue?vue&type=template&id=74f0c1c6"
import script from "./CouponPublish.vue?vue&type=script&lang=js"
export * from "./CouponPublish.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__